function updateHulkCartPrices() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      cart.items.forEach(item => {
        const variantId = item.variant_id;
        const discountedPrice = item.price;
        const originalPrice = item.original_price;

        const priceEls = document.querySelectorAll(`[data-key^="${variantId}:"]`);

        priceEls.forEach(el => {
          if (el.hasAttribute("data-cart-item-final-price")) {
            // Sale price (discounted)
            el.textContent = Shopify.formatMoney(discountedPrice, Shopify.money_format);
          } else if (el.hasAttribute("data-cart-item-original-price")) {
            // Strikethrough regular price
            el.textContent = Shopify.formatMoney(originalPrice, Shopify.money_format);
          } else if (el.hasAttribute("data-cart-item-regular-price")) {
            // If discounted, override regular price display
            if (discountedPrice !== originalPrice) {
              el.textContent = Shopify.formatMoney(discountedPrice, Shopify.money_format);
            }
          }
        });
      });
    });
}
document.addEventListener('DOMContentLoaded', updateHulkCartPrices);

document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
  form.addEventListener("submit", () => {
    setTimeout(updateHulkCartPrices, 700); // Delay to wait for popup to open
  });
});
